import ReactMarkdown from 'react-markdown';

import * as S from './Growth.style';
import * as T from './Growth.types';

export const Growth: React.FC<T.GrowthCollection> = ({ items, subtitle, title }) => {
  return (
    <>
      {title && subtitle && (
        <S.ConteudoPlataforma className="section">
          <h3>{title}</h3>
          <p>{subtitle}</p>
        </S.ConteudoPlataforma>
      )}

      {items.map((item, index) => {
        return (
          <S.ConteudoPlataforma id={`recurso-${index}`} key={item.title} className="section">
            <S.Container>
              <S.Text>
                <p>
                  <strong>{item.subtitle}</strong>
                </p>
                <h3>{item.title}</h3>
                <ReactMarkdown>{item.description}</ReactMarkdown>
              </S.Text>
              <S.Image>
                <img
                  className="icon"
                  src={`/images/blob-${index + 1}.svg`}
                  width={500}
                  height={400}
                />
                <img
                  className="img"
                  src={item.image.url}
                  alt={item.title}
                  width={751}
                  height={543}
                />
              </S.Image>
            </S.Container>
          </S.ConteudoPlataforma>
        );
      })}
    </>
  );
};
